export default {
  path: '/publishers',
  name: 'publishers',
  component: () => import(/* webpackChunkName: "list-view-publishers" */ './ListViewPublishers'),
  meta: {
    requiresAuth: true
  }
}
